export const messages = {
  en: {
    noticeDetail: {
      title: 'Notice Details',
      back: 'Back',
      titleLabel: 'Title',
      noticeType: 'Notice Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      content: 'Content',
      fetchError: 'Failed to fetch notice details'
    }
  },
  zh: {
    noticeDetail: {
      title: '公告详情',
      back: '返回',
      titleLabel: '标题',
      noticeType: '公告类型',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '创建时间',
      content: '公告内容',
      fetchError: '获取公告详情失败'
    }
  },
'zh-TW': {
    noticeDetail: {
      title: '公告詳情',
      back: '返回',
      titleLabel: '標題',
      noticeType: '公告類型',
      startTime: '開始時間',
      endTime: '結束時間',
      createTime: '創建時間',
      content: '公告內容',
      fetchError: '獲取公告詳情失敗'
    }
  }
};